import { gql } from 'apollo-angular';


export interface AgencyTypeId {
  id: string;
  description: string;
  textKey?: string;
  admin?: boolean;
  im?: boolean;
  coss?: boolean;
  applicant?: boolean;
  production?: boolean;
  service?: boolean;
}

export const agencyTypeIdDetailed = gql`
  fragment agencyTypeIdDetailed on AgencyTypeId {
    id
    description
  }
`;
